import { useNavigate } from 'react-router-dom';
import type { Product } from '@/api/models';
import { useCartActions } from './useCart';
import { useUI } from '@/context/UIContext';

/** Adds a size to the cart and shows the drop-down confirmation with a "View cart" button. */
export function useAddToCart() {
  const { add } = useCartActions();
  const { showToast } = useUI();
  const navigate = useNavigate();

  const addToCart = async (product: Product, sizeSlug: string, quantity = 1) => {
    const sizeName = product.sizes.find((s) => s.slug === sizeSlug)?.name ?? sizeSlug;
    try {
      await add.mutateAsync({ product, size: sizeSlug, quantity });
      showToast(`${quantity} × “${product.name}” (${sizeName}) has been added to your cart.`, {
        action: { label: 'View cart', onClick: () => navigate('/cart') },
      });
      return true;
    } catch (e) {
      showToast((e as Error).message, { tone: 'error' });
      return false;
    }
  };

  return { addToCart, adding: add.isPending };
}
